import { configureStore } from '@reduxjs/toolkit';

import coreReducer from './core';

export const store = configureStore({
  reducer: {
    core: coreReducer,
  },
});

export const storeDispatch = store.dispatch;
export const storeSelector = store.getState;
